// components/Loading.jsx
import React from "react";
import styled, { keyframes } from "styled-components";

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
`;

const ContentArea = styled.div`
  flex: 1;
  padding: 2rem;
  background-color: #f3f7ff;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`;

const Dots = styled.div`
  display: flex;
  gap: 10px;
`;

const Dot = styled.div`
  width: 14px;
  height: 14px;
  background-color: #3a79ed;
  border-radius: 50%;
  animation: ${bounce} 1.4s infinite ease-in-out both;
  animation-delay: ${props => props.delay};
`;

export default function LoadingComLayout() {
  return (
    <ContentArea>
      <Dots>
        <Dot delay="0s" />
        <Dot delay="0.2s" />
        <Dot delay="0.4s" />
      </Dots>
    </ContentArea>
  );
}
